export class StringHelpers {
  /**
   * isNumeric tests a string and returns true when it's a decimal value
   */
  static isNumeric = (val: string) => /^\d+$/.test(val);

  /**
   * capitaliseFirstLetter capitalises only the very first character of a string, leaving the
   * rest unedited
   */
  static capitaliseFirstLetter = (val: string) => val.charAt(0).toUpperCase() + val.slice(1);

  /**
   * titleCaseString capitalises the first letter of each word in a string
   */
  static titleCaseString = (val: string) => val.replace(/([A-Z])/g, ' $1').trim();

  static camelCaseString = (val: string) =>
    val
      .replace(/_/g, ' ')
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, '');

  static removeWhiteSpace(inputString: string): string {
    const inputAfterWhitespaceRemoved = inputString?.replace(/\s/g, '');
    return inputAfterWhitespaceRemoved;
  }
}
